import { RentalInformationForm } from "./forms/RentalInformationForm";

export const validateFormValues = (formValues = {}) => {
  const error = {
    ...RentalInformationForm.validate(formValues),
  };

  return error;
};
